import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import primaryComponents from "../../../../../components/primaryComponents";
import { PlusIcon } from "../../../../../assets/svgIcons";
import { RoutedModal } from "../../../../../components/common";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";
import {
  BusinessAccountForm,
  BusinessAccountTable,
} from "../../../../../components/secondaryComponents/IntegratedTerminals";
import { intergratedTerminalInfo } from "../../../../../localdata/intergratedTerminalInfo";
import { useAllBusinessConnections } from "./useAllBusinessConnections";

export const AllBusinessConnections = () => {
  const {
    isLoadingAccounts,
    terminalType,
    businessAccounts,
    isConnectAccount,
    setIsConnectAccount,
  } = useAllBusinessConnections();
  const navigate = useNavigate();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Market - Payment Integrations"
      description="Manage terminals connections"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={` ${globalStyles.pagePaddings} ${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">
              Manage {intergratedTerminalInfo?.[terminalType]?.primaryName}
            </h4>
            <p>
              Manage and connect lumi app to{" "}
              {intergratedTerminalInfo?.[
                terminalType
              ]?.primaryName?.toLowerCase()}{" "}
              accounts to collect payment seemlessly in your store
            </p>
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{businessAccounts?.length} Accounts</p>
            <div className="d-flex flex-wrap" style={{ gap: "5px" }}>
              <primaryComponents.Button
                classNames={"btn btn--outline"}
                onClick={() =>
                  navigate(
                    pathConstants.APPS_INTEGRATION_TERMINALS +
                      `?terminal_type=${terminalType}`,
                  )
                }
              >
                View Connected Terminals
              </primaryComponents.Button>
              <primaryComponents.Button
                classNames={"btn btn--primary"}
                onClick={() => setIsConnectAccount(true)}
              >
                <PlusIcon className="mr-1" />
                Create New Account
              </primaryComponents.Button>
            </div>
          </div>

          <div className={`${globalStyles.tableWrapper}`}>
            {/* table section */}
            <secondaryComponents.LoaderHelper
              isLoading={isLoadingAccounts}
              classNames="mt-5"
            >
              <BusinessAccountTable connectionList={businessAccounts} />
            </secondaryComponents.LoaderHelper>
          </div>

          <RoutedModal
            isActive={isConnectAccount}
            width={600}
            headerTitle="Connect Interswitch Account"
            closeModal={() => setIsConnectAccount(false)}
            style={{ height: "auto" }}
          >
            <BusinessAccountForm
              closeModal={() => setIsConnectAccount(false)}
            />
          </RoutedModal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
